import {getServerUrl} from "./getServerUrl";

export const apiUrl = process.env.REACT_APP_API_URL;

export function getPrintUrl(type, id, accessToken = null, subdomain = null) {
    const baseUrl = getServerUrl(type);
    if (baseUrl) {
        let printUrl = `${apiUrl + baseUrl}/${id}/pdf`;

        if (accessToken && subdomain)
            printUrl += `?token=${accessToken}&cs=${subdomain}`;

        return printUrl;
    }
    return null;
}
